import Icons from 'assets/icons';
import MarkFeatureCard from './mark-feature-card';

import { Box } from 'ui/box';
import { Stack } from 'ui/stack';

import Button from 'components/partials/button/button';

interface MessageExampleButton {
  label: string;
  prompt: string;
}

const MESSAGE_EXAMPLES: MessageExampleButton[] = [
  {
    label: 'YoY comparison',
    prompt: 'Compare my 2026 Year-over-Year in-state/out-of-state deposit pool',
  },
  {
    label: 'Inquiry source performance',
    prompt:
      'Can you help me understand which of our sources produce inquiries that actually convert?',
  },
  {
    label: 'Cohort & Peer benchmarking',
    prompt:
      'How does my yield rate from sophomore/junior search compare to the market?',
  },
  {
    label: 'Socioeconomic profile',
    prompt:
      'Can you show how my applicants have been distributed across income bands for 2024, 2025, and 2026?',
  },
  {
    label: 'Geographic profile',
    prompt:
      'Can you show how my applicants have been distributed across in-state vs out-of-state for 2024, 2025, and 2026?',
  },
];

interface MarkWalkthroughStep3Props {
  onExamplePromptClick: (prompt: string, label: string) => void;
}

const MarkWalkthroughStep3 = ({
  onExamplePromptClick,
}: MarkWalkthroughStep3Props) => (
  <Stack sx={{ flex: '1 1 0%', gap: 2, pt: 2 }}>
    <h2 className="text-xl font-bold text-gray-900">
      MARK gets better with use.
    </h2>

    <Box
      sx={{
        display: 'grid',
        width: '100%',
        gridTemplateColumns: 'repeat(1, minmax(0, 1fr))',
        gap: 2,
        mb: 3,
        '@media (min-width: 780px)': {
          gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        },
      }}
    >
      <MarkFeatureCard
        icon={Icons.ThumbsUp}
        title="Feedback"
        description="Help improve MARK. Use the ‘like’ or ‘dislike’ buttons on any response and include a brief explanation."
      />
      <MarkFeatureCard
        icon={Icons.Clock}
        title="Session history"
        description="Every conversation is saved automatically. Pick up where you left off or revisit past insights anytime."
      />
    </Box>
    <Box>
      <h3 className="font-bold text-gray-900 mb-1">Start with essentials</h3>
      <Stack direction="row" sx={{ flexWrap: 'wrap', gap: 1.25 }}>
        {MESSAGE_EXAMPLES.map((example) => (
          <Button
            key={example.label}
            type="button"
            variant="reserve-outlined"
            size="sm"
            onClick={() => onExamplePromptClick(example.prompt, example.label)}
            data-testid="mark-walkthrough-example-prompt"
          >
            {example.label}
          </Button>
        ))}
      </Stack>
    </Box>
  </Stack>
);

export default MarkWalkthroughStep3;
